import React, { useState, useContext } from 'react'
import MenuIcon from '@material-ui/icons/Menu'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import MenuItem from '@material-ui/core/MenuItem'
import { Link as LinkTo } from 'react-router-dom'
import Link from '@material-ui/core/Link'

import AuthContext from 'store/AuthContext'

const UserMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { state, dispatch } = useContext(AuthContext)
  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <IconButton
        onClick={event => {
          handleClick(event)
        }}
      >
        <MenuIcon />
      </IconButton>

      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
        id="SettingsMenu"
        keepMounted
      >
        <Link component={LinkTo} to="/dashboard">
          <MenuItem onClick={handleClose}>DashBoard</MenuItem>
        </Link>
        {state.auth && (
          <MenuItem onClick={() => dispatch({ type: 'doLogout' })}>
            Logout
          </MenuItem>
        )}
      </Popover>
    </div>
  )
}

export default UserMenu
